const VERSION = "3.0.3";
export {
  VERSION
};
